import {Button} from "antd";
import React, {FC, memo} from "react";
import {GetColumnsForTableDocument, TablesEnum, useUpdateTableColumnSettingsMutation} from "../../generated/graphql";
import useHighestRole from "../../helpers/useHighestRole";
import Roles from "../../../shared/models/roles";
import {magenta, red} from "@ant-design/colors";

type ActivateAllColumnsButtonProps = {
    allColumns: {[key: string]: string};
    setSelectedColumns: (e: Array<string>) => void;
    tablesEnum?: TablesEnum;
};

const ActivateAllColumnsButton: FC<ActivateAllColumnsButtonProps> = ({allColumns, setSelectedColumns, tablesEnum}) => {
    const highestRole = useHighestRole();
    const isSuperUser = highestRole === Roles.Superuser;

    const [updateUserColumns] = useUpdateTableColumnSettingsMutation();

    const handleActivateAllColumns = () => {
        const allColumnKeys = Object.keys(allColumns);

        if (tablesEnum) {
            updateUserColumns({
                variables: {
                    updateTableColumnSettingsInput: {
                        table: tablesEnum,
                        columns: allColumnKeys,
                    },
                },
                refetchQueries: [
                    "GetColumnsForTable",
                    {
                        query: GetColumnsForTableDocument,
                        variables: {table: tablesEnum},
                    },
                ],
            });
        }

        setSelectedColumns(allColumnKeys);
    };

    if (!isSuperUser) {
        return null;
    }

    return (
        <Button style={{color: magenta[4], paddingLeft: "4px", paddingRight: "4px"}} type="link" size="small" onClick={handleActivateAllColumns}>
            {"Alle Spalten aktivieren"}
        </Button>
    );
};

export default memo(ActivateAllColumnsButton);
